const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SimpleProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          origin: 'center',
          perView: 1.6,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            loop: false,
            slides: {
              origin: 'auto',
              perView: 3.3,
              spacing: 5,
            },
          },
          '(min-width: 901px)': {
            loop: false,
            slides: {
              origin: 'auto',
              perView: 4.3,
              spacing: 5,
            },
          },
          '(min-width: 1201px)': {
            loop: false,
            slides: {
              origin: 'auto',
              perView: 5.3,
              spacing: 5,
            },
          },
          '(min-width: 1440px)': {
            loop: false,
            slides: {
              origin: 'auto',
              perView: 6.3,
              spacing: 5,
            },
          },
          '(min-width: 1600px)': {
            loop: false,
            slides: {
              origin: 'auto',
              perView: 7.3,
              spacing: 5,
            },
          },
        },
        detailsChanged: (instance) => {
          this.els.slide.elements.forEach((slideEl, index) => {
            const matchingSlide = instance.track.details.slides[index]

            slideEl.setAttribute('aria-hidden', matchingSlide.portion < 0.8)
          })
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('simple-product-carousel')) {
  customElements.define('simple-product-carousel', SimpleProductCarousel)
}
